import {
  FAULT_REASON_BAR_SEGMENTS,
  computeLitSegments,
  segmentOpacity,
} from "./faultReasonBarSegments";

interface FaultReasonBarProps {
  /** Proporção do motivo sobre o total de falhas do período, 0-100. */
  percentage: number;
}

/**
 * Barra de magnitude segmentada (Figma node 233:2693 "HorizontalBar 03") —
 * 7 blocos de 8px, os acesos degradam do preto sólido conforme a proporção
 * do motivo dentro do total de falhas do período.
 */
export const FaultReasonBar = ({ percentage }: FaultReasonBarProps) => {
  const litCount = computeLitSegments(percentage);

  return (
    <div className="flex h-2 flex-1 items-center gap-0.5">
      {Array.from({ length: FAULT_REASON_BAR_SEGMENTS }).map((_, index) => (
        <div
          key={index}
          className="h-2 flex-1 rounded-full bg-black"
          style={{ opacity: segmentOpacity(index, litCount) }}
        />
      ))}
    </div>
  );
};
